export const BILL_TRACKING_EDUCATION_QUERY_PARAM = 'bte';
